import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronRightExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 17a1 1 0 0 1-.77-1.63L11.97 12 9.23 8.63a1 1 0 1 1 1.55-1.26l3.25 4a1 1 0 0 1 0 1.26l-3.25 4A1 1 0 0 1 10 17"
    />
  </svg>
);
export default SvgChevronRightExtraSmall;
